module.exports = __webpack_public_path__ + "static/media/Badge_SanteFemme.7e623325.png";